<!--单选题维护-->
<template>
<div class="Radio">
    <el-form-item label="题目" required>
        <uEditor :content="formData.subject" ref="subject" @getUEditorContent="getUEditorSubjectContent"></uEditor>
    </el-form-item>
    <el-form-item :label="'选项'+endlish[index]" required v-for="(item, index) in formData.optioninfo" :key="index">
        <uEditor :index='index' :content="item.optionsinfo" ref="uEditor" @getUEditorContent="getUEditorContent"></uEditor>
        <el-radio v-model="isrightanswer" :label="index" @change="setChecked">设为正确答案</el-radio>
        <div class="del" v-if="formData.optioninfo.length>1" @click="delOption(index)">
            <img src="@/common/images/other/icon-del.png" alt="del" />
        </div>
    </el-form-item>
    <el-form-item>
        <el-button v-if="formData.optioninfo.length < endlish.length" type="primary" plain @click="addOption">+ 新增选项
        </el-button>
    </el-form-item>
    <el-form-item label="试题解析">
        <uEditor :content="formData.quesanalysis" ref="quesanalysis"
                 @getUEditorContent="getUEditorQuesanalysisContent"></uEditor>
    </el-form-item>
    <el-form-item>
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
    </el-form-item>
</div>
</template>

<script>
import $ from 'jquery'
import UEditor from 'base/uEditor/uEditor4'

export default {
    name: 'Radio',
    props: ['formData', 'type'],
    data() {
        return {
            endlish: 'ABCDEFGHIJ', // 英文列表
            optioninfo: {   // 试题选项信息，选择题有效，解析之后为一个数组，前端选先后顺序组装 optionsinfo 选项名称 isrightanswer 是否正确答案 0否 1是
                optionid: '',
                optionsinfo: '',   // 选项名称
                isrightanswer: 0  // 是否正确答案，接口返回
            },
            isrightanswer: ''//正确答案的索引
        }
    },
    mounted() {
        if (this.type == 1) {
            // 非编辑情况下
            this._initRadio()
        } else {
            this.editMsg(this.formData)
        }
    },
    methods: {
        setChecked(val) {
            this.formData.optioninfo.forEach((obj, i) => {
                if (val != i) {
                    obj.isrightanswer = 0
                } else {
                    this.isrightanswer = i
                    obj.isrightanswer = 1
                }
            })
        },
        _initRadio() {    // 初始化数据
            this.$nextTick(() => {
                this.addOption()
                this.addOption()
            })
        },
        cancel() {  // 返回题库
            this.$emit('cancel')
        },
        addOption() { // 增加新选项
            let obj = this._.cloneDeep(this.optioninfo)
            this.formData.optioninfo.push(obj)
        },
        delOption(index) { // 删除选项 index 下标
            //把正确答案删除了，重置正确答案为空
            if(this.formData.optioninfo[index].isrightanswer === 1){
                this.isrightanswer = ''
            }
            this.formData.optioninfo.splice(index, 1)
            // 删除无用Textarea 标签
            this.$nextTick(() => {
                $("textarea[name='editorValue']").each(function () {
                    let style = $(this).attr('style')
                    if (style == 'width: 0px; height: 0px;') {
                        $(this).remove()
                    }
                })
            })
        },
        editMsg(formData) {   // 编辑内容
            this.$nextTick(() => {
                formData.optioninfo.forEach((obj, index) => {
                    if (obj.isrightanswer == '1') {
                        this.isrightanswer = index
                    }
                })
            })
        },
        submit() {    // api 数据提交
            let item = this._.cloneDeep(this.formData)
            // console.log('this.isrightanswer',this.isrightanswer)
            // console.log('item',item)
            item.optioninfo.forEach((obj, index) => {
                if (!obj.optionsinfo) {
                    this.$message.error('选项' + letter[index] + '题目不能为空')
                } else {
                    if (index == this.isrightanswer) {
                        obj.isrightanswer = '1'
                    } else {
                        obj.isrightanswer = '0'
                    }
                }
            })
            if (this.isrightanswer === '') {
                this.$message.error('答案不能为空')
                return
            }
            this.$emit('childSubmitFormApi', JSON.stringify(item))
        },
        getUEditorSubjectContent(content) {
            this.formData.subject = content
        },
        getUEditorQuesanalysisContent(content) {
            this.formData.quesanalysis = content
        },
        getUEditorContent(content, index) {
            this.formData.optioninfo[index].optionsinfo = content
        },
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        UEditor
    }
}
</script>

<style lang="scss" type="text/scss" scope>
.Radio {
    .uEditor {
        .ue_btn {
            display: none;
        }
    }
    .del {
        position: absolute;
        top: 0;
        right: -40px;
        cursor: pointer;
        img {
            width: 12px;
            height: 12px;
        }
    }
}
</style>
